import { useState, useEffect } from "react"
import logo from "../images/brand/logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWallet, faCreditCard, faUser, faUsers, faCircleNotch, faArrowRight} from '@fortawesome/free-solid-svg-icons'
import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { Toaster, toast } from 'react-hot-toast';
import { useNavigate, Link, useLocation } from 'react-router-dom'
import Select from "react-select";

function Enrollment2() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [loading, setLoading] = useState(true);
  const [disable, setDisable] = useState(true);
  const [employer_id, setEmployer_id] = useState(state?.employer_id ?? localStorage.getItem('user.employer_id') ?? '');
  const [age, setAge] = useState(state?.age ?? localStorage.getItem('user.age') ?? '');
  const [contribution, setContribution] = useState(state?.contribution ?? localStorage.getItem('user.contribution') ?? '');
  const [salary, setSalary] = useState(state?.salary ?? localStorage.getItem('user.salary') ?? '');
  const [tax_type, setTax_type] = useState(state?.tax_type ?? localStorage.getItem('user.tax_type') ?? 'Pre-tax');
  const [effective_date, setEffective_date] = useState(state?.effective_date ?? localStorage.getItem('user.effective_date') ?? 'false');
  const [investment, setInvestment] = useState(state?.investment ?? localStorage.getItem('user.investment') ?? 'target');
  const [stocks, setStocks] = useState(state?.stocks ?? localStorage.getItem('user.stocks') ?? 60);
  const [bonds, setBonds] = useState(state?.bonds ?? localStorage.getItem('user.bonds') ?? 30);
  const [cash, setCash] = useState(state?.cash ?? localStorage.getItem('user.cash') ?? 10);

  const [email, setEmail] = useState(localStorage.getItem('user.email') ?? '');
  const [userDetails, setUserDetails] = useState([]);
  useEffect(() => {
    if(!salary || !contribution || !tax_type || !effective_date){
        navigate('/enrollment1', { replace: true });
    }else{
        setLoading(false)
    }
  }, [email]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/login.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchuser1: true, email: email})
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success" && data.user) {
            setUserDetails(data.user);
            setLoading(false);
        } else {
            setLoading(true);
        }
    })
    .catch(err => {
      console.error(err)
      setLoading(false);
    })
  }, [email]);
  useEffect(() => {
    if(investment && (investment !== "custom" || (investment === "custom" && stocks && bonds && cash))){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [investment, stocks, bonds, cash]);

  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const investmentoptions = [
    { value: "target", label: "Target Date 2035 Fund (defualt)" },
    { value: "balanced", label: "Balanced Fund (60/40)" },
    { value: "custom", label: "Build Custom Allocation" },
  ];

  const validateInvestment = (value) => {
    setInvestment(value);
    if(value == "balanced"){
      setStocks(60);
      setBonds(40);
      setCash(0);
    }else{
      setStocks(60);
      setBonds(30);
      setCash(10);
    }
  }

  if (loading || !userDetails || typeof userDetails !== 'object' || Object.keys(userDetails).length === 0) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="min-vh-100 d-flex flex-column text-white" style={{backgroundColor: 'rgb(5, 8, 11)', padding: '0px 32px 144px'}}>
    <div><Toaster/></div>
    <header className="d-flex align-items-center justify-content-between" style={{padding: '32px 0px'}}>
        <img src={logo} alt="logo" className="app-logo"/>
        <Link to="/" className="text-light text-decoration-none" style={{fontSize: '14px'}}>
        Back to homepage
        </Link>
    </header>
    <main>
        <div className="container mt-5">
            <div className="row">
                <div className="col-lg-8 offset-lg-2 mb-5">
                    <h5 className="mb-0" style={{fontWeight:'900'}}>401(k) Enrollment</h5>
                    <div className="mt-5 d-flex align-items-center progressD" style={{gap:'20px'}}>
                      <Link to="/enrollment" className="d-flex flex-column align-items-center noLink">
                          <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px'}}>
                          <FontAwesomeIcon icon={faUser} style={{fontSize: '16px'}} />
                          </div>
                          <p className="mb-0 fw-semibold mt-1 text-prime text-nowrap" style={{fontSize:'12px'}}>Personal</p>
                      </Link>
                      <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                      <Link to="/enrollment1" className="d-flex flex-column align-items-center noLink">
                          <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                          <FontAwesomeIcon icon={faWallet} style={{fontSize: '16px'}} />
                          </div>
                          <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Contributions</p>
                      </Link>
                      <div className="bg-prime" style={{height:'3px',maxWidth:'200px',width:'100%'}}></div>
                      <Link to="/enrollment2" className="d-flex flex-column align-items-center noLink">
                          <div className="rounded-circle d-flex align-items-center justify-content-center bg-prime" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                          <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '16px'}} />
                          </div>
                          <p className="mb-0 fw-semibold mt-1 text-nowrap text-prime" style={{fontSize:'12px'}}>Investment</p>
                      </Link>
                      <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                      <Link to="/enrollment3" className="d-flex flex-column align-items-center noLink">
                          <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                          <FontAwesomeIcon icon={faUsers} style={{fontSize: '16px'}} />
                          </div>
                          <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Beneficiary</p>
                      </Link>
                      <div style={{height:'3px',backgroundColor:'#ffffff0c',maxWidth:'200px',width:'100%'}}></div>
                      <Link to="/enrollment4" className="d-flex flex-column align-items-center noLink">
                          <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minHeight:'50px',minWidth:'50px',width:'50px',height:'50px',backgroundColor:'#ffffff0c'}}>
                          <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '16px'}} />
                          </div>
                          <p className="mb-0 fw-semibold mt-1 text-nowrap" style={{fontSize:'12px'}}>Review</p>
                      </Link>
                    </div>
                    <div className="mycard p-3 mt-4">
                        <div className="row">
                            <div className="col-12">
                                <div className="mb-2">
                                    <label className="mb-1" style={{fontSize:'14px'}}>Investment option</label>
                                    <Select 
                                        options={investmentoptions} 
                                        value={investmentoptions.find((opt) => opt.value === investment)}
                                        onChange={(e) => validateInvestment(e.value)}
                                        styles={darkThemeStyles}
                                        className="w-full"
                                        placeholder="Investment option"
                                    />
                                </div>
                            </div>
                            {investment == "custom" && (
                            <>
                              <div className="col-12">
                                <p className="mb-1 text-secondary" style={{fontSize:'12px'}}>Set custom allocation percentages (must sum to 100)</p>
                              </div>
                              <div className="col-md-4">
                                  <div className="mb-2">
                                      <label className="mb-1" style={{fontSize:'14px'}}>Stocks</label>
                                      <input
                                          type="text"
                                          className="form-control py-2"
                                          placeholder="0"
                                          value={stocks}
                                          onChange={(e) => setStocks(e.target.value)}
                                          required
                                      />
                                  </div>
                              </div>
                              <div className="col-md-4">
                                  <div className="mb-2">
                                      <label className="mb-1" style={{fontSize:'14px'}}>Bonds</label>
                                      <input
                                          type="text"
                                          className="form-control py-2"
                                          placeholder="0"
                                          value={bonds}
                                          onChange={(e) => setBonds(e.target.value)}
                                          required
                                      />
                                  </div>
                              </div>
                              <div className="col-md-4">
                                  <div className="mb-2">
                                      <label className="mb-1" style={{fontSize:'14px'}}>Cash Reserve</label>
                                      <input
                                          type="text"
                                          className="form-control py-2"
                                          placeholder="0"
                                          value={cash}
                                          onChange={(e) => setCash(e.target.value)}
                                          required
                                      />
                                  </div>
                              </div>
                            </>
                            )}
                        </div>
                        <div className="d-flex justify-content-end">
                        {disable ? (
                            <div className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block disabled">Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></div>
                        ) : (
                            <Link to="/enrollment3" state={{employer_id:employer_id, email:email, age:age, effective_date:effective_date, tax_type:tax_type, contribution:contribution, salary:salary, investment:investment, stocks:stocks, bonds:bonds, cash:cash}} className="myBtn mt-4 text-center px-4 py-3 rounded-2 d-block" onClick={() => { 
                                localStorage.setItem('user.investment', investment);
                                localStorage.setItem('user.stocks', stocks);
                                localStorage.setItem('user.bonds', bonds);
                                localStorage.setItem('user.cash', cash);
                            }}>Next <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '14px'}} /></Link>
                        )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
    </div>
  )
}

export default Enrollment2